import React, { useRef, useState } from "react";
import ProjectsAccordion from "../../components/Accordions/ProjectsAccordion";
import ApiSession from "../../api/ApiSession";
import userScope from "../CustomHooks/userScope";
const apiSession = new ApiSession();
const DisasterManagement = ({
    openModalBess,
    setOpenModalBess,
    bessControllerList,
    setBessControllerList,
    callSnackbar,
    softwareOptions = ["BESS Controller", "BESS Controller HMI"],
    groupVersion = {},
}) => {
    const userScopeAcess = userScope();
    const [title, setTitle] = useState("");
    const [isDisable, setIsDisable] = useState(false);
    const [availableVersions, setAvailableVersions] = useState(false);
    const [loading, setLoading] = useState(false);
    const [bessData, setBessData] = useState({
        softwareName: '',
        version: '',
        device: '',
        description: '',
        modifiedOn: '',
        modifiedBy: '',
        fileName: '',
        machineExpertVersion: '',
        releaseDate: ''
    });
    const [selectedFile, setSelectedFile] = useState(null);
    const inputRefBess = useRef(null);
    const [versionError, setVersionError] = useState("")

    const closeModalBess = () => {
        setOpenModalBess(false);
        setAvailableVersions(false);
        setSelectedFile(null);
        setBessData({
            softwareName: '',
            version: '',
            device: '',
            description: '',
            modifiedOn: '',
            modifiedBy: '',
            fileName: '',
            machineExpertVersion: '',
            releaseDate: ''
        });
        setVersionError("");
        if (inputRefBess.current) inputRefBess.current.value = null;
    };
    const handleOpenBessModal = (bessType, data, mode) => {
        setTitle(`${mode} ${data.softwareName} Package`);
        setIsDisable(mode === "Edit");
        setBessData(data);
        setOpenModalBess(true);
    };


    const handleBessController = (e) => {
    const { name, value } = e.target;
    const trimmed = value.trim();
    if(name === "softwareName"){
        setVersionError("");
    setAvailableVersions(false);
    setBessData({
        softwareName: trimmed,
        version: '',
        device: '',
        description: '',
        modifiedOn: '',
        modifiedBy: '',
        fileName: '',
        machineExpertVersion: '',
        releaseDate: ''
    });
    return;
    }
    if (name === "version") {
      setBessData((prev) => ({ ...prev, [name]: trimmed }));
        const VERSION_FULL = /^\d{1,2}(?:\.\d{1,2}){0,2}$/;
      const sw = bessData?.softwareName?.trim();
      const allowedVersions =
        sw && Array.isArray(groupVersion?.[sw]) ? groupVersion[sw] : null;

      const isKnownVersion = !!allowedVersions && allowedVersions.includes(trimmed);
      setAvailableVersions(isKnownVersion);

      // Real-time feedback (optional)
      const isValidFormat = VERSION_FULL.test(trimmed);
      setVersionError(
        isValidFormat
          ? ""
          : "Invalid version. Use x, x.y, or x.y.z (1–2 digits per part)."
      );

      return;
    }
    setBessData((prev) => ({ ...prev, [name]: value }));
  };

    const fileChangedHandler = (event) => {
        const { files } = event.target;
        if (files.length) {
            if (files[0].size > 204857600) {
                callSnackbar("error", " Zip file should be less than 200MB");
                event.target.value = null;
                setSelectedFile(null);
            } else if (files[0].type !== "application/x-zip-compressed") {
                callSnackbar("error", "Invalid file format, Please select .zip file");
                event.target.value = null;
                setSelectedFile(null);
            } else {
                setSelectedFile(files[0]);
                setBessData((prev) => ({ ...prev, fileName: files[0].name }));
                let reader = new FileReader();
                reader.onloadend = () => { };
                reader.readAsDataURL(files[0]);
            }
        }
    };

    const handleUpload = (type) => {
        if (!bessData.softwareName) {
            callSnackbar("error", "Please select software name");
            return;
        } else if (!bessData.version) {
            callSnackbar("error", "Please enter version");
            return;
        } else if (!selectedFile) {
            callSnackbar("error", "Please select file to upload");
            return;
        }else if(versionError){
            callSnackbar("error", "Invalid version. Use x, x.y, or x.y.z (1–2 digits per part).");
            return;
        } else {
            if (selectedFile && ! groupVersion[bessData.softwareName].includes(bessData.version)) {
                setBessControllerList((prevList) => [...prevList, bessData]);
                let fd = new FormData();
                fd.append("file", selectedFile);
                fd.append("softwareName", bessData.softwareName);
                fd.append("version", bessData.version);
                fd.append("device", bessData.device);
                fd.append("description", bessData.description);
                fd.append("modifiedOn", bessData.modifiedOn);
                fd.append("modifiedBy", bessData.modifiedBy);
                fd.append("machineExpertVersion", bessData.machineExpertVersion);
                fd.append("releaseDate", bessData.releaseDate);
                setLoading(true);
                apiSession
                    .uploadBESSControllerPackage(fd)
                    .then(() => {

                        callSnackbar("success", "BESS Controller package uploaded successfully");
                        setLoading(false);
                        setOpenModalBess(false);
                    })
                    .catch((error) => {
                        if (error.response !== undefined) {
                            if (error.response.status === 400) {
                                callSnackbar("error", "Invalid package");
                            } else {
                                callSnackbar("error", "Error in uploading package");
                            }
                        } else {
                            callSnackbar("error", "Error in uploading package");
                        }

                        setLoading(false);
                        setOpenModalBess(false);
                        setSelectedFile(null);
                        setBessData({
                            softwareName: '',
                            version: '',
                            device: '',
                            description: '',
                            modifiedOn: '',
                            modifiedBy: '',
                            fileName: '',
                            machineExpertVersion: '',
                            releaseDate: ''
                        });
                    });
            } else {
                callSnackbar("error", "Version already exists for the selected software name");
                setLoading(false);
            }
            if (inputRefBess.current) inputRefBess.current.value = null;
        }


    };
    const addBessPackage = () => {
        const today = new Date().toISOString().slice(0, 10);
        setIsDisable(false);
        setTitle("Add BESS Package");
        setBessData((prev) => ({
            ...prev,
            modifiedOn: today,
            modifiedBy: userScopeAcess.name || ""
        }));
        setOpenModalBess(true);
    }
    return (
        <>
            <ProjectsAccordion key={"SchneiderElectricBESS"} label={`Schneider Electric BESS`}>
                <div className="row">
                    <div className="col-md-12 d-flex justify-content-end mb-2 pr-2">
                        <se-button
                            option="raised"
                            size="small"
                            color="primary"
                            icon="action_add_flat"
                            onClick={addBessPackage}
                            style={{ marginRight: "3px" }}
                        >
                            Add BESS Package
                        </se-button>
                    </div>
                    <div className="col-md-12">
                        {bessControllerList && bessControllerList?.length > 0 ? (
                            <table className="table table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th>Software Name</th>
                                        <th>Version</th>
                                        <th>Device</th>
                                        <th>Description</th>
                                        <th>Modified On</th>
                                        <th>Modified By</th>
                                        <th>File Name</th>
                                        <th>Ecostructure Machine Expert version</th>
                                        <th>Release Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bessControllerList?.map((bess) => (
                                        <tr key={bess?.id}>
                                            <td>{bess?.softwareName}</td>
                                            <td>{bess?.version}</td>
                                            <td>{bess?.device}</td>
                                            <td>{bess?.description}</td>
                                            <td>{bess?.modifiedOn}</td>
                                            <td>{bess?.modifiedBy}</td>
                                            <td>{bess?.fileName}</td>
                                            <td>{bess?.machineExpertVersion}</td>
                                            <td>{bess?.releaseDate}</td>
                                            <td>
                                                <se-icon
                                                    onClick={() => handleOpenBessModal(bess.id, bess, "Edit")}
                                                    size="small"
                                                    color="secondary"
                                                    className="se-life-green"
                                                >
                                                    action_editor
                                                </se-icon>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="d-flex justify-content-center">No BESS Controller data available.</div>
                        )}
                    </div>
                </div>

            </ProjectsAccordion>
            <se-dialog
                id="dialog-complex-delete-confirm"
                open={openModalBess}
                can-backdrop="false"
                size="large"
            >
                <se-dialog-header>{title}</se-dialog-header>
                <se-dialog-content
                    className="se-dialog-content "
                    style={{ minHeight: "150px" }}
                >
                    {/* {loading ? (
                        <se-loading className="mt-3" loading={loading}></se-loading>
                    ) :  */}
                    {(
                        <><se-loading className="mt-3" loading={loading}></se-loading>
                            <div className="row mt-1">
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-md-4 my-auto col-form-label text-right" htmlFor="softwareName">
                                            Software Name<span className="se-mandatory">*</span>
                                        </label>
                                        <div className="col-md-8 my-auto">
                                            <select
                                                className="form-control form-control-sm col-md-12 inline p-0"
                                                id="softwareName"
                                                name="softwareName"
                                                value={bessData.softwareName}
                                                onChange={handleBessController}
                                                disabled={isDisable}
                                            >
                                                <option value="" disabled defaultValue hidden>Select bess</option>
                                                {
                                                    softwareOptions?.map((option) => (
                                                        <option key={option} value={option}>
                                                            {option}
                                                        </option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-md-4 my-auto col-form-label text-right" htmlFor="version">
                                            Version<span className="se-mandatory">*</span>
                                        </label>
                                        <div className="col-md-8 my-auto">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="version"
                                                value={bessData.version}
                                                maxLength="25"
                                                onChange={handleBessController}
                                                disabled = {bessData.softwareName === ""}
                                            />
                                                {availableVersions && <div className="invalid-feedback-custom">Version already used, please update to a new version.</div>}
                                                    {!!versionError && <div className="invalid-feedback-custom">{versionError}</div>}

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-md-4 my-auto col-form-label text-right" htmlFor="device">
                                            Device
                                        </label>
                                        <div className="col-md-8 my-auto">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="device"
                                                value={bessData.device}
                                                maxLength="25"
                                                onChange={handleBessController}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-md-4 my-auto col-form-label text-right" htmlFor="fileName">
                                            File Name
                                        </label>
                                        <div className="col-md-8 my-auto">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="fileName"
                                                value={bessData.fileName}
                                                maxLength="25"
                                                onChange={handleBessController}
                                            />
                                        </div>
                                    </div>
                                </div> */}

                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-md-4 my-auto col-form-label text-right" htmlFor="releaseDate">
                                            Release Date
                                        </label>
                                        <div className="col-md-8 my-auto">
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                name="releaseDate"
                                                value={bessData.releaseDate}
                                                maxLength="25"
                                                onChange={handleBessController}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-md-4 my-auto col-form-label text-right" htmlFor="ecostruxureMachineExpertVersion">
                                            Ecostruxure Machine Expert version
                                        </label>
                                        <div className="col-md-8 my-auto">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="ecostruxureMachineExpertVersion"
                                                value={bessData.machineExpertVersion}
                                                maxLength="25"
                                                onChange={handleBessController}
                                            />
                                        </div>
                                    </div>
                                </div>
                                 <div className="col-md-12">
                                      <div className="form-group  row align-items-center">
                                        <label className="col-md-2 my-auto col-form-label text-right" htmlFor="description">
                                            Description
                                        </label>
                                        <div className="col-md-10 my-auto">

                                            <textarea
                                                className="form-control form-control-sm"
                                                id="description"
                                                rows="3"
                                                name="description"
                                                placeholder="Enter the description"
                                                value={bessData.description}
                                                onChange={handleBessController}
                                            ></textarea>
                                        </div>
                                    </div>
                                 </div>
                              
                               
                            </div>
                            

                        </>
                    )}
                </se-dialog-content>

                {(
                    <se-dialog-footer className="position-relative row" style={{ marginBottom: "0.5rem" }}  >
                        <div className="col-md-1"></div>
                        <div className="col-md-7  pl-0">
                            <input
                                type="file"
                                onChange={fileChangedHandler}
                                className="form-control-file form-control-sm fileNameDisplay"
                                name="file"
                                ref={inputRefBess}
                            />
                        </div>
                        <div className="col-md-3 text-right pr-1">
                            <div className="ml-0 " style={{ marginRight: "0.3rem" }}>
                                <se-button onClick={closeModalBess}>Cancel</se-button>
                                {/* Add permission check if needed: UserScope.access.uploadFile */}
                                <se-button
                                    option="flat"
                                    color="primary"
                                    // disabled={selectedFile === null}
                                    onClick={handleUpload}
                                >
                                    Upload
                                </se-button>
                                {/* End permission check */}
                            </div>
                        </div>
                    </se-dialog-footer>
                )}
            </se-dialog>
        </>
    );

}
export default DisasterManagement;